"use client";
import BugReportIcon from "@mui/icons-material/BugReport";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { adminLyricsLinterService } from "~/connectors/lyrics.connector";


function AdminLyricsLintButton({ slug }: { slug: string }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{ success: boolean; message: string } | null>(null);

  const handleLint = async () => {
    setLoading(true);
    setResult(null);

    // Trigger lint as a background job and don't block the UI waiting for it.
    adminLyricsLinterService.lintSlug(slug)
      .then((res) => {
        setResult({ success: res.success, message: res.message });
        if (!res.success) {
          setLoading(false);
        }
      })
      .catch((e) => {
        // If triggering the job fails immediately, show an error.
        setResult({
          success: false,
          message: `Eroare la pornirea linterului. Încearcă din nou. Eroare: ${e instanceof Error ? e.message : String(e)}`
        });
        setLoading(false);
      });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, pl: { xs: 1, md: 0 }, flexWrap: "wrap" }}>
      <Tooltip title="Rulează linterul automat pentru acest vers">
        <Button
          size="small"
          variant="text"
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <BugReportIcon fontSize="small" />}
          onClick={handleLint}
          disabled={loading}
        >
          Lint acum!
        </Button>
      </Tooltip>
      {result && (
        <Typography
          variant="caption"
          color={result.success ? "success.main" : "error.main"}
        >
          {result.message}
        </Typography>
      )}
    </Box>
  );
}

export default AdminLyricsLintButton;